class AddButtonController {

    constructor($timeout, messageService, loginoutService, validateService, addGuestService) {
        this.$timeout = $timeout;
        this.messageService = messageService;
        this.loginoutService = loginoutService;
        this.validateService = validateService;
        this.addGuestService = addGuestService;
    }

    $onInit () {
        this.clearTimer = undefined;
    }

    addToBasket () {
        this.error = null;
        this.loading = false;
        this.success = false;
        this.errorFields = [];
        this.guests = this.addGuestService.getGuests();

        if (!this.validate()) {
            return;
        }

        this.loading = true;

        return this.checkLogin()
            .then((response) => {
                if (!response) {
                    this.messageService.add(`Sorry, you must log in to continue.`);
                    this.messageService.failure();
                    this.loading = false;
                    return;
                }

                let oldOffer = this.item.offer;

                if (this.item.offer) {
                    this.item.offer = this.item.offer.id;
                }

                this.$timeout.cancel(this.clearTimer);
                this.basket.changeStatus('checkout');

                return this.basket.addToBasket(this.guests, this.item)
                    .then(() => {
                        this.loading = false;
                        this.item.offer = oldOffer;
                        this.addGuestService.setState({
                            existingGuests: this.basket.contents.guest_details,
                            guests: []
                        });

                        if (this.basket.success) {
                            this.success = true;
                            this.clearTimer = this.$timeout(() => {
                                this.success = false;
                            }, 3000);
                        }

                        // Get new availability
                        return this.getAvailabilitySingle(false);
                    });
            });
    }

    validate () {
        this.item.gender = this.gender;

        let error = this.validateService.invalidItemOrGuests(this.item, this.guests, this.status);

        if (error) {
            this.messageService.add(error);
            this.messageService.failure();
            return false;
        }

        return true;
    }

    isDisabled () {
        if (this.loading || this.status === 1) {
            return true;
        }

        if (this.item) {
            if (!this.item.available || ((this.item.quantity + this.item.minimum_guests) < this.item.minimum_guests)) {
                return true;
            }
        }

        return false;
    }

    canAddToBasket (checkForPhone = false) {
        if (this.status === 1) {
            return false;
        }

        if (this.item) {
            if (this.item.available && checkForPhone) {
                return this.item.phone_only;
            }

            return this.item.available;
        }

        return false;
    }

    checkLogin () {
        return new Promise(resolve => {
            if (this.basket.empty() && this.loginoutService.isAllowed()) {
                return this.loginoutService.login(true)
                    .then((response) => {
                        resolve(response);
                    });
            }
            resolve(true);
        });
    }
}

AddButtonController.$inject = ['$timeout', 'messageService', 'loginoutService', 'validateService', 'addGuestService'];

export default AddButtonController;



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/basket/controllers/addButton.controller.js